import Modal from "react-modal";
import { IoMdClose } from "react-icons/io";
import "./CustomModal.scss";

const CustomModal = ({
  isOpen,
  onRequestClose,
  children,
  btnClose,
  contentLabel,
  onClose,
  chatLoading,
  modalBottom,
  imageDetail,
}) => {
  const handleClose = () => {
    if (onClose) {
      onClose(); // onClose가 있을 경우 실행
    }
    onRequestClose(); // 항상 실행
  };

  const baseClassName = `modal-content ${chatLoading ? "chat-Loading" : ""} ${
    modalBottom ? "modal-bottom" : ""
  } ${imageDetail ? "image-detail" : ""}`;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel={contentLabel}
      shouldCloseOnOverlayClick={false}
      closeTimeoutMS={300}
      bodyOpenClassName={"ReactModal__Body--open"}
      htmlOpenClassName={"ReactModal__Html--open"}
      ariaHideApp={true}
      className={{
        base: baseClassName,
        afterOpen: "modal-content_after-open",
        beforeClose: "modal-content_before-close",
      }}
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 999,
        },
      }}
    >
      {btnClose ? (
        <div className="absolute flex justify-end right-4 top-4">
          <IoMdClose
            className="text-4xl cursor-pointer"
            onClick={handleClose}
          />
        </div>
      ) : null}
      {children}
    </Modal>
  );
};

export default CustomModal;
